var map = {
	"./basketball.webp": 1649,
	"./bti-img.webp": 1650,
	"./bti-title-en.webp": 1651,
	"./cup.webp": 1652,
	"./football.webp": 1653,
	"./im-img.webp": 1654,
	"./im-title-en.webp": 1655,
	"./sb-img.webp": 1656,
	"./sb-title-cn.webp": 1657,
	"./sb-title-en.webp": 1658,
	"./sbo-img.webp": 1659,
	"./sbo-title-cn.webp": 1660,
	"./sbo-title-en.webp": 1661,
	"./sport-bg.webp": 1662,
	"./sport-ctg.webp": 1663,
	"./title-cn.webp": 1664,
	"./title-en.webp": 1665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 788;